import classNames from 'classnames';
import React, { useContext } from 'react';
import * as styles from './FieldSet.module.scss';

const IsFieldSetDisabledContext = React.createContext(false);

export const useIsFieldSetDisabled = () =>
  useContext(IsFieldSetDisabledContext);

interface FieldSetProps
  extends React.FieldsetHTMLAttributes<HTMLFieldSetElement> {
  children?: React.ReactNode;
  legend?: React.ReactNode;
  margin?: 'none' | 'normal';
}

const FieldSet = ({
  legend,
  children,
  margin = 'normal',
  ...props
}: FieldSetProps) => (
  <fieldset
    className={classNames(styles.fieldSet, {
      [styles.marginNormal]: margin === 'normal',
    })}
    {...props}
  >
    <IsFieldSetDisabledContext.Provider value={props.disabled ?? false}>
      {!!legend && <legend className={styles.legend}>{legend}</legend>}
      {children}
    </IsFieldSetDisabledContext.Provider>
  </fieldset>
);

export default FieldSet;
